// import PropTypes from 'prop-types';
import React, {createContext, useCallback, useContext, useState} from 'react';
import {useFilter} from '@/contexts/FilterContext';


export const createContextList = (usePagination, name, pageConfig, queryConfig) => {
  const Context = createContext();

  function Provider(props) {
    const {search, filter, bodyParams} = useFilter();
    const [openModal, setOpen] = useState({open: false});
    const [tableData, setTableData] = useState(undefined);

    const onOpenModal = useCallback((payload) => {
      setOpen({open: true, payload});
    }, []);

    const onCancelModal = useCallback(() => {
      setOpen({open: false});
    }, []);

    const {
      page, data, totalPages, setPage, isFetching, activeKey, setSize, size
    } = usePagination(search, filter, pageConfig, queryConfig, bodyParams);


    return (
      <Context.Provider value={{
        page, data: tableData || data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize, size, setTableData
      }} {...props} />
    );
  }

  function useList() {
    const context = useContext(Context);
    if (context === undefined) {
      throw new Error(`use${name} must be used within a ${name}Provider`);
    }
    const {
      page, data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize, size, setTableData
    } = context;

    return {
      page, data, totalPages, setPage, isFetching, activeKey, openModal, onOpenModal, onCancelModal, setSize, size, setTableData
    };
  }

  Provider.propTypes = {};


  return {Provider, useList};
};
